import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Colors from "../../Constant/Colors";
import images from "../../Constant/images";
import { Dot } from "../SideBar/style";
import SmartImage from "../SmartImage";
import {
  Container,
  EachCourse,
  EachCourseHeading,
  EachFolder,
  EachFolderHeading,
  FlexEndDiv,
  FolderList,
} from "./style";
import FolderIcon from "@mui/icons-material/Folder";
import {
  BoldMed,
  RegSmPri,
  HorizontalAlign,
  VerticalLeftAlign,
  HorizontalLeftAlign,
  BoldSm,
  RegMed,
} from "../CustomStyles";
import SearchBar from "../SearchBar";
import { useSelector, useDispatch } from "react-redux";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import ArticleIcon from "@mui/icons-material/Article";
import AssignmentIcon from "@mui/icons-material/Assignment";
import DescriptionIcon from "@mui/icons-material/Description";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import VideocamIcon from "@mui/icons-material/Videocam";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "../IconButton";

import {
  deleteFolderRequest,
  getContentRequest,
  getCoursesRequest,
  postFolderRequest,
  toggleFolderCourses,
  toggleFolders,
} from "../../Redux/actions/home";
import ModalComponent from "../Modal";
import MasKInput from "../IconInputField";
import { handleSideBarNavigation } from "../../Redux/actions/auth";
const FolderComponent = ({ handleView }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const { folders, courses } = useSelector((state) => state.home);
  const [folderList, setFolderList] = useState([]);
  const [searchFolder, setSearchFolder] = useState("");
  const [openModal, setOpenModal] = useState({
    isOpen: false,
    name: "",
  });
  const handleOpenModal = (type, id) => {
    setOpenModal((prev) => ({
      ...prev,
      isOpen: true,
      type,
      id,
    }));
  };
  const handleCloseModal = () => {
    setOpenModal((prev) => ({
      ...prev,
      isOpen: false,
      name: "",
      type: null,
      id: null,
    }));
  };
  const createFolder = () => {
    handleCloseModal();
    if (openModal?.type === 'delete') {
      let data = {
        id: openModal?.id,
      };
      dispatch(deleteFolderRequest(data));
    } else {
      let data = { name: openModal?.name };
      dispatch(postFolderRequest(data));
    }
  };
  // console.log('openModal',folders);
  const handleFolderName = (e) => {
    setOpenModal((prev) => ({
      ...prev,
      name: e,
    }));
  };

  const handleFolders = (folder) => {
    dispatch(toggleFolders(folder?.folder_name));
  };
  const handleCourses = (folderId, courseId) => {
    let payload = {
      folderId,
      courseId,
    };
    dispatch(toggleFolderCourses(payload));
  };

  const handleContent = (course, content) => {
    dispatch(
      handleSideBarNavigation({
        id: 1,
        icon: images.course,
        selectedIcon: images.course,
        title: "Course",
        isSelected: true,
        navigate: "/courses",
      })
    );
    if (location.pathname === "/courses") {
      handleView("courseMaterial", course, content);
    } else {
      navigate("/courses", { state: { id: course?.id, course, content } });
    }
    if (!courses.length) dispatch(getCoursesRequest(course?.id));
    setTimeout(() => {
      dispatch(getContentRequest(course?.id, content));
    }, 100);

    // }
  };

  const handleSearch = (key) => {
    setSearchFolder(key);
    let arr = [...folders];
    arr = arr.filter((f) =>
      f.folder_name.toLowerCase().startsWith(key.toLowerCase())
    );
    setFolderList(arr);
  };

  useEffect(() => {
    setFolderList(folders);
  }, [folders]);

  const customStyle = {
    eachContent: {
      width: "80%",
      marginTop: 10,
      marginLeft: 25,
      marginBottom: 10,
    },
    articleIcon: {
      color: "#666",
      marginRight: 5,
      fontSize: 16,
    },
    btnDiv: {
      width: "100%",
      display: "flex",
      justifyContent: "center",
      position: "absolute",
      bottom: 0,
      paddingBottom: 10,
      backgroundColor: Colors.whiteThemeColor,
    }
  };


  return (
    <Container>
      {/* --------------------------Main Heading ------------------------------ */}
      <HorizontalAlign style={{ marginTop: 10 }}>
        <SmartImage
          src={images.myCourses}
          style={{ height: 25, width: 25, marginRight: 10 }}
        />
        <VerticalLeftAlign style={{ marginLeft: 10 }}>
          <BoldMed>My Courses</BoldMed>
        </VerticalLeftAlign>
      </HorizontalAlign>
      {/* -------------------------- SearchBar ------------------------------ */}
      <SearchBar search={searchFolder} handleSearch={handleSearch} />
      {/* -------------------------- Folders ------------------------------ */}
      <HorizontalAlign style={{ marginTop: 20 }}>
        <FolderIcon style={{ color: "#6666", marginRight: 10 }} />
        <BoldMed>Document Folder</BoldMed>
      </HorizontalAlign>
      {/* -------------------------- Folders List ------------------------------ */}
      {folderList.length ? (
        <FolderList>
          {folderList.map((eachFolder) => (
            <EachFolder toggle={eachFolder?.toggle}>
              {/* -------------------------- Folders Heading ------------------------------ */}
              <EachFolderHeading onClick={() => handleFolders(eachFolder)}>
                <HorizontalLeftAlign>
                  <FolderIcon
                    style={{ color: "#666", marginRight: 5, fontSize: 16 }}
                  />
                  <BoldSm>{eachFolder?.folder_name}</BoldSm>
                </HorizontalLeftAlign>
                <HorizontalAlign style={{ width: 30 }}>
                  {eachFolder?.toggle ? (
                    <RemoveIcon style={{ fontSize: 14, marginRight: 5 }} />
                  ) : (
                    <AddIcon style={{ fontSize: 14, marginRight: 5 }} />
                  )}
                  <DeleteIcon
                    style={{ height: 14, width: 14, color: "red" }}
                    onClick={() => handleOpenModal("delete", eachFolder?.id)}
                  />
                </HorizontalAlign>
              </EachFolderHeading>
              <FlexEndDiv>
                {eachFolder?.courses?.length ? (
                  <>
                    {eachFolder?.courses.map((eachCourse) => (
                      <EachCourse toggle={eachCourse?.toggleCourse}>
                        {/* -------------------------- Folders Courses ------------------------------ */}

                        <EachCourseHeading
                          onClick={() =>
                            handleCourses(eachFolder.id, eachCourse?.name)
                          }
                        >
                          <HorizontalLeftAlign>
                            <ArticleIcon style={customStyle.articleIcon} />
                            <BoldSm>{eachCourse?.name}</BoldSm>
                          </HorizontalLeftAlign>
                          {eachCourse?.toggleCourse ? (
                            <RemoveIcon style={{ fontSize: 14 }} />
                          ) : (
                            <AddIcon style={{ fontSize: 14 }} />
                          )}
                        </EachCourseHeading>

                        <div style={customStyle.eachContent}>
                          {eachCourse?.content.length ? (
                            eachCourse?.content.map((content) => (
                              <HorizontalLeftAlign
                                style={{ cursor: "pointer", marginTop: 5 }}
                                onClick={() =>
                                  handleContent(
                                    eachCourse,
                                    content === "image"
                                      ? "photos"
                                      : content === "text"
                                        ? "notes"
                                        : content === "quiz"
                                          ? "quiz"
                                          : "videos"
                                  )
                                }
                              >
                                {/* -------------------------- Folders Courses Content ------------------------------ */}

                                <>
                                  {content === "image" ? (
                                    <CameraAltIcon
                                      style={{
                                        color: Colors.photoIcon,
                                        fontSize: 16,
                                      }}
                                    />
                                  ) : content === "content" ? (
                                    <AssignmentIcon
                                      style={{
                                        color: Colors.AssIcon,
                                        fontSize: 16,
                                      }}
                                    />
                                  ) : content === "quiz" ? (
                                    <SmartImage src={images.quiz} style={{ width: 20, height: 20 }} />

                                  ) : (
                                    <VideocamIcon
                                      style={{
                                        color: Colors.vidIcon,
                                        fontSize: 16,
                                      }}
                                    />
                                  )}
                                </>
                                <BoldSm style={{ marginLeft: 10 }}>
                                  {content === "image"
                                    ? "Photos"
                                    : content === "text"
                                      ? "Notes"
                                      : content === "quiz"
                                        ? "Quiz"
                                        : "Content"}
                                </BoldSm>
                              </HorizontalLeftAlign>
                            ))
                          ) : (
                            <HorizontalAlign style={{ marginTop: 10 }}>
                              <RegSmPri>No content to show</RegSmPri>
                            </HorizontalAlign>
                          )}
                        </div>
                      </EachCourse>
                    ))}
                  </>
                ) : (
                  <HorizontalAlign style={{ width: "100%", marginBottom: 5 }}>
                    <RegSmPri>No courses to show</RegSmPri>
                  </HorizontalAlign>
                )}
              </FlexEndDiv>
            </EachFolder>
          ))}
        </FolderList>
      ) : (
        <HorizontalAlign style={{ marginTop: 20 }}>
          <RegSmPri>No folders to show</RegSmPri>
        </HorizontalAlign>
      )}

      <div style={customStyle.btnDiv}>
        <IconButton
          text={"Add New"}
          style={{ width: 100, height: 30 }}
          textStyle={{ fontWeight: "400" }}
          onClick={handleOpenModal}
        />
      </div>
      {openModal?.isOpen && (
        <ModalComponent
          closeModal={handleCloseModal}
          openModal={openModal?.isOpen}
          disabledYesBtn={openModal?.type !== 'delete' && openModal?.name?.length < 1}
          heading={openModal?.type === 'delete' ? "Delete Folder" : `Create New Folder`}
          yesBtnTxt={openModal?.type === 'delete' ? "Delete" : "Add Folder"}
          noBtnTxt={"Cancel"}
          yesBtn={createFolder}
          noBtn={handleCloseModal}
        >
          {openModal?.type === 'delete' ? (
            <RegMed>Are you sure want to delete folder?</RegMed>
          ) : (
            <MasKInput
              placeholder={"Folder Name"}
              value={openModal?.name}
              onChange={(e) => handleFolderName(e.target.value)}
            />
          )}
        </ModalComponent>
      )}
    </Container>
  );
};

export default FolderComponent;
